import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: { key: 'AIzaSyCN49QiI-YWMjURZxsZ5L_00QZb9NSswJw' }
})